export default "__VITE_ASSET__XR9_ewTx__"